'use strict';
import { observable, action } from 'mobx';

class GlobalStore {
  @observable alarmStatus = false;
  @observable alarmTitle = '';
  @observable alarmDescription = '';

  @observable loadingStatus = false;
  @observable loadingTip = '';

  @action.bound
  showAlarm(title, description) {
    this.alarmStatus = true;
    this.alarmTitle = title;
    this.alarmDescription = description;
  }
  @action
  hideAlarm() {
    this.alarmStatus = false;
    this.alarmTitle = '';
    this.alarmDescription = '';
  }
}
export default new GlobalStore();



// WEBPACK FOOTER //
// ./src/store/Global.js